import { FETCH_ROLE_SUBS_FAILURE, FETCH_ROLE_SUBS_REQUEST, FETCH_ROLE_SUBS_SUCCESS, FETCH_ROLE_SUBS_SUCCESS_2, FETCH_ROLE_SUB_FAILURE, FETCH_ROLE_SUB_REQUEST, FETCH_ROLE_SUB_SUCCESS } from "../actions/actions";



// rolesubReducer.js
const initialState = {
    rolesubs: [],
    rolesubs2: [],
    rolesub: {},
    rolesubSelect: {},
    loadingRolesub:false,
    loadingRolesubSelect:false,
    loadingRolesubs:false,
    errorRolesubs:null,
    errorRolesub:null
    // ... autres états spécifiques à rolesubReducer
  };
  
  const rolesubReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ROLE_SUB_REQUEST:
        // Dispatch une action pour définir loading sur true dans le globalReducer
        return {
          ...state,
          loadingRolesub:true,
          errorRolesubs:""
          // Autres manipulations d'état pour la demande de récupération des rolesubs
        };
        case FETCH_ROLE_SUB_SUCCESS:
        return {
          ...state,
          loadingRolesub:false,
          errorRolesubs:"",
          rolesub:action.payload
        };
        case FETCH_ROLE_SUB_FAILURE:
        return {
          ...state,
          loadingRolesub:false,
          errorRolesubs:action.payload
        };


      case FETCH_ROLE_SUBS_REQUEST:
        return {
          ...state,
          loadingRolesubs:true,
          errorRolesubs:""
        };
       
      case FETCH_ROLE_SUBS_SUCCESS:
        return {
          ...state,
          rolesubs: action.payload,
          loadingRolesubs:false,
          errorRolesubs:""
          // Autres manipulations d'état pour le succès de la récupération des rolesubs
        };
        case FETCH_ROLE_SUBS_SUCCESS_2:
        return {
          ...state,
          rolesubs2: action.payload,
          loadingRolesubs:false,
          errorRolesubs:""
          // Autres manipulations d'état pour le succès de la récupération des rolesubs
        };
        
      case FETCH_ROLE_SUBS_FAILURE:
        // Dispatch une action pour définir loading sur false dans le globalReducer et enregistrer l'erreur
        return {
          ...state,
          loadingRolesubs:false,
          errorRolesubs:action.payload
          // Autres manipulations d'état pour l'échec de la récupération des rolesubs
        };
      // ... autres cas pour d'autres actions liées aux rolesubs

        
      default:
        return state;
    }
  };
  
  export default rolesubReducer;

  

